import TruncatedComment from './TruncatedComment';

export default TruncatedComment;
